













































import { Object } from 'lodash'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
import { State, Getter, Action, Mutation, namespace } from 'vuex-class'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import { ICenter } from '@/store/modules/views/center/states'

@Component
export default class Center extends VueExtendedBaseComponent {
  private options: OptionTable = {
    page: 1,
    sortBy: ['createdAt'],
    sortDesc: [true],
    itemsPerPage: 10,
    search: '',
  }
  private id = ''
  private name = ''
  private email = ''
  private currentData = {}
  private filters = {}
  private loadingDataTable = true
  private createDialog = false
  private editDialog = false
  private deleteDialog = false
  private resetDialog = false
  private clearTimeoutValue: NodeJS.Timeout = setTimeout(() => undefined, 100)

  get headers(): Array<{ text: string; value: string }> {
    return this.headerLists
  }

  get items() {
    return this.itemLists
  }

  get paginationLists() {
    return this.pagination
  }

  @Action('center/getCenterList')
  private getCenterList!: (headerParams: {
    headers: {
      page: number,
      limit: number,
      sortBy: string,
      sortDesc: boolean,
      search: string,
      filter: string,
    },
  }) => void

  @Getter('center/headerLists')
  private headerLists!: Array<{ text: string; value: string }>

  @Getter('center/itemLists')
  private itemLists!: () => void

  @Getter('center/pagination')
  private pagination!: () => void

  private async getList() {
    this.loadingDataTable = true
    await this.getCenterList({
      headers: {
        page: this.options.page,
        limit: this.options.itemsPerPage,
        sortBy: _.get(this.options, 'sortBy[0]', 'createdAt'),
        sortDesc: _.get(this.options, 'sortDesc[0]', true),
        search: Buffer.from(this.options.search).toString('base64'),
        filter: Buffer.from(JSON.stringify(this.filters)).toString('base64'),
      },
    })
    this.loadingDataTable = false
  }

  private doGetLists() {
    clearTimeout(this.clearTimeoutValue)
    this.loadingDataTable = true
    this.clearTimeoutValue = setTimeout(this.getList, 1000)
  }

  private openDialog(center: {name: string, email: string, id: string}, modelDialog: 'editDialog' | 'resetDialog' | 'deleteDialog') {
    this.currentData = _.cloneDeep(center)
    this[modelDialog] = true
  }

  private addNewCenterDialog() {
    this.createDialog = true
  }

  private created() {
    this.getList()
  }
  private mapAddressText(text: ICenter['address']) {
      return this.mapAddress(text)
  }
}
